import {RSAA} from "redux-api-middleware";

export const LIVE_UPDATE_LOADING = 'LIVE_UPDATE_LOADING';
export const LIVE_UPDATE_SET = 'LIVE_UPDATE_SET';


export const fetchLiveUpdateAction = classification => (dispatch, getState) =>
    dispatch({
        [RSAA]: {
            endpoint: `/api/v1/game/${getState().games.current.id}/classification/${classification.id}/achievementTeamLiveUpdate`,
            method: 'GET',
            credentials: 'same-origin',
            types: [
                LIVE_UPDATE_LOADING,
                {
                    type: 'SUCCESS',
                    payload: (action, state, res) => {
                        res.json().then(
                            json => {
                                dispatch({type: LIVE_UPDATE_SET, payload: json})
                            }
                        )
                    }
                },
                'FAILURE'
            ]
        }
    });
